import { render, staticRenderFns } from "./history-table.vue?vue&type=template&id=0f436b67&scoped=true"
import script from "./history-table.vue?vue&type=script&lang=js"
export * from "./history-table.vue?vue&type=script&lang=js"
import style0 from "./history-table.vue?vue&type=style&index=0&id=0f436b67&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f436b67",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/data/workspace/KCC_AUDIT_PROD_Frontend/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f436b67')) {
      api.createRecord('0f436b67', component.options)
    } else {
      api.reload('0f436b67', component.options)
    }
    module.hot.accept("./history-table.vue?vue&type=template&id=0f436b67&scoped=true", function () {
      api.rerender('0f436b67', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client-view/pbc-management/history-table.vue"
export default component.exports